import FeedbackService from '../../service/feedback'

const Action = {
    FETCH_FEEDBACK_LIST: '[feedback] FETCH LIST',
}

const ActionCreator = {
    fetchFeedbackList() {
        return async dispatch => {
            const feedbackList = await FeedbackService.list()
            dispatch({ type: Action.FETCH_FEEDBACK_LIST, feedbackList })
            return feedbackList
        }
    },
}

const initialState = {
    feedbackList: [],
}

const Reducer = function (state = initialState, action) {
    switch (action.type) {
        case Action.FETCH_FEEDBACK_LIST:
            return {
                ...state,
                feedbackList: action.feedbackList,
            }
        default:
            return state
    }
}

export default { Action, ActionCreator, Reducer }



// WEBPACK FOOTER //
// ./src/store/actionreducers/feedback.js